<template>
  <iframe
    v-if="activeApp && appURL"
    :src="appURL"
    :width="activeApp.width || '100%'"
    :height="activeApp.height || '100%'"
    class="plugin-wrapper"
    ref="iframe"
    :id="activeApp.extensionId"
    :sandbox="sandbox"
    @load="connectApp()"
  />
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { sanitizeUserForSDK, sanitizeSiteForSDK } from '@/utils/common'

export default {
  name: 'SitePlugin',
  computed: {
    ...mapState({
      activeApp: (state) => state.sites.activeApp,
      activePlugin: (state) => state.sites.activePlugin,
      user: (state) => state.user.current,
      activeSite: (state) => state.sites.active,
    }),
    appURL() {
      if (!this.activeApp) return ''
      let { siteSrc, component: componentPath, pickerURL } = this.activeApp
      if (pickerURL) return pickerURL // Picker
      if (this.activeApp.param && this.activeApp.param.component)
        componentPath = this.activeApp.param.component
      if (componentPath && typeof componentPath === 'string') {
        // componentPath is a string path
        if (this.isAbsoluteURL(componentPath))
          return componentPath + window.location.search
        else {
          if (siteSrc && typeof siteSrc === 'string' && siteSrc.endsWith('/')) siteSrc = siteSrc.slice(0, -1)
          if (componentPath.startsWith('/'))
            componentPath = componentPath.slice(1)
          return `${siteSrc}/${componentPath}${window.location.search}`
        }
      }
      // If no component path, use siteSrc directly (for marketplace plugins)
      if (siteSrc && typeof siteSrc === 'string') {
        return siteSrc + window.location.search
      }
      return ''
    },
    sandbox() {
      // Default permissions that should always be included
      const defaultPermissions = [
        'allow-scripts',
        'allow-same-origin',
        'allow-forms',
        'allow-presentation',
      ]
      
      // Get requested permissions from plugin
      const requestedPermissions = this.activeApp?.sandboxPermissions || []
      
      // Merge defaults with requested permissions, removing duplicates
      const allPermissions = [
        ...defaultPermissions,
        ...requestedPermissions.filter(p => !defaultPermissions.includes(p)),
      ]
      
      return allPermissions.join(' ')
    },
  },
  mounted() {
    if (!this.showMoreAppBar) this.setShowMoreAppBar(true)
  },
  methods: {
    ...mapMutations('sites', [
      'setActiveApp',
      'setActivePlugin',
      'setShowMoreAppBar',
    ]),
    isAbsoluteURL(urlString) {
      if (!urlString || typeof urlString !== 'string') return false
      return (
        urlString.indexOf('http://') === 0 ||
        urlString.indexOf('https://') === 0
      )
    },
    connectApp() {
      const ref = this.$refs.iframe
      if (ref && ref.contentWindow) {
        ref.contentWindow.postMessage(
          {
            type: 'CONNECT',
            src: this.activeApp.siteSrc,
            pluginId: this.activeApp.pluginId,
            extensionId: this.activeApp.extensionId,
            initialArgs: {
              currentUser: sanitizeUserForSDK(this.user),
              activeSite: sanitizeSiteForSDK(this.activeSite),
              param: this.activeApp.param,
            },
          },
          '*'
        )
      }
    },
  },
}
</script>

<style scoped>
.plugin-wrapper {
  height: calc(100vh - 150px);
  width: calc(100% - 32px);
  margin-left: 24px;
  margin-right: 8px;
  border: none;
}
</style>
